import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';
import {AdditionalProcessor} from '@em/shared/mapping-engine/domain-models';

export function additionalProcessorValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const additionalProcessors = control.value as AdditionalProcessor;

    if (additionalProcessors?.find_replace) {
      if (!additionalProcessors?.find_replace.find) {
        return {additionalProcessors: true};
      }
    }

    return null;
  };
}
